<script setup lang="ts">
import {IconNames, icons} from "../services/icons";
import {computed} from "vue";
import {CssClasses} from "../types/ui";

const sizes = {
	small: '0.8rem',
	large: '2rem',
	medium: '1rem',
}

const props = withDefaults(
	defineProps<{
		icon: IconNames,
		element?: 'button' | 'a' | 'span',
		size?: keyof typeof sizes | number,
		cssClass?: CssClasses,
	}>(),
	{
		size: 'medium',
		element: 'span',
	}
);

const iconDef = computed(() => icons[props.icon]);
const iconSize = computed(() => (
	typeof props.size === 'number'
		? props.size + 'rem'
		: sizes[props.size]
));
const cssClasses = computed(() => ['icon', iconDef.value.cssClass, props.cssClass]);

</script>

<template>
	<component :is="props.element" :class="cssClasses" :style="{'--icon-size': iconSize}">
		<template v-if="iconDef.text">{{ iconDef.text }}</template>
		<img v-if="iconDef.icon" :src="iconDef.icon"/>
	</component>
</template>

<style scoped>

</style>